// Transport modes, column ids and form field names for a customer's transportation routes.

// The server's `transportation_type` enum — one transport_detail row per mode.
export const TRANSPORT_MODE = Object.freeze({
  train: 'TRAIN',
  ship: 'SHIP',
  road: 'ROAD',
});

export const TRANSPORT_MODES = Object.freeze([
  TRANSPORT_MODE.train,
  TRANSPORT_MODE.ship,
  TRANSPORT_MODE.road,
]);

export const TRANSPORT_MODE_LABEL_KEYS = Object.freeze({
  [TRANSPORT_MODE.train]: 'CUSTOMER_TRANSPORT_MODE_TRAIN',
  [TRANSPORT_MODE.ship]: 'CUSTOMER_TRANSPORT_MODE_SHIP',
  [TRANSPORT_MODE.road]: 'CUSTOMER_TRANSPORT_MODE_ROAD',
});

// Per-mode column headers — one key each, never built from the mode label.
export const TRANSPORT_MODE_COLUMN_KEYS = Object.freeze({
  [TRANSPORT_MODE.train]: {
    distance: 'FIELD_DISTANCE_TRAIN',
    emissionFactor: 'FIELD_EMISSION_FACTOR_TRAIN',
    total: 'FIELD_TOTAL_TRAIN_EMISSIONS',
  },
  [TRANSPORT_MODE.ship]: {
    distance: 'FIELD_DISTANCE_SHIP',
    emissionFactor: 'FIELD_EMISSION_FACTOR_SHIP',
    total: 'FIELD_TOTAL_SHIP_EMISSIONS',
  },
  [TRANSPORT_MODE.road]: {
    distance: 'FIELD_DISTANCE_ROAD',
    emissionFactor: 'FIELD_EMISSION_FACTOR_ROAD',
    total: 'FIELD_TOTAL_ROAD_EMISSIONS',
  },
});

export const TRANSPORT_MODE_FIELDS = Object.freeze({
  distance: 'distance',
  emissionFactor: 'emissionFactor',
});

export const transportFieldName = (mode, field) => `transport.${mode}.${field}`;

export const CUSTOMER_TRANSPORT_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  routeName: 'routeName',
  shippingFrom: 'shippingFrom',
  sentTo: 'sentTo',
  totalEmissions: 'totalEmissions',
  actions: 'actions',
});

export const TRANSPORT_FIELDS = Object.freeze({
  routeName: 'routeName',
  // FacilityField's own name; its value is a buildFacilityValue string.
  shippingFrom: 'facilityId',
  sentTo: 'sentToId',
});

export const REQUIRED_TRANSPORT_FIELDS = Object.freeze([
  TRANSPORT_FIELDS.routeName,
  TRANSPORT_FIELDS.shippingFrom,
  TRANSPORT_FIELDS.sentTo,
]);

export const EMPTY_TRANSPORT_FORM = Object.freeze({
  [TRANSPORT_FIELDS.routeName]: '',
  [TRANSPORT_FIELDS.shippingFrom]: '',
  [TRANSPORT_FIELDS.sentTo]: '',
  ...Object.fromEntries(
    TRANSPORT_MODES.flatMap((mode) =>
      Object.values(TRANSPORT_MODE_FIELDS).map((field) => [transportFieldName(mode, field), '']),
    ),
  ),
});
